<template>
  <section>
    <b-modal
      :active="show"
      @close="closeModal"
      has-modal-card
    >
      <div class="modal-card">
        <modal-factory>
          <template #modal-header />
          <template #modal-main />
          <template #modal-footer />
        </modal-factory>
      </div>
    </b-modal>
  </section>
</template>

<script>
import ModalFactory from '@/components/ModalFactory'
import { mapGetters } from 'vuex'

export default {
  name: 'Modal',
  beforeDestroy () {
    this.$eventBus.$off('modalChanges')
  },
  components: {
    ModalFactory
  },
  computed: {
    ...mapGetters('modal', [
      'show'
    ])
  },
  watch: {
    show: {
      handler: function (changes) {
        // ! everytime changed the modal visibility check if the closeModal event has fired
        if (changes) {
          this.$eventBus.$on('closeModal', () => {
            this.closeModal()
          })
        }
      },
      deep: true
    }
  },
  methods: {
    closeModal () {
      this.$store.dispatch('modal/disable')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Modal.vue